
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import { UiTooltip } from '../../keen-ui'

export default defineComponent({
  name: 'EpbToggle',
  components: {
    UiTooltip,
  },
  props: {
    options: {
      type: Array as PropType<
        Array<{ id: string; content: string; tooltip?: string; disabled?: boolean }>
      >,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    label: String,
    tooltip: String,
    tooltipPosition: {
      // top, bottom, left, right (all of them can be concatenated with '-start' or '-end')
      type: String,
      default: 'top',
    },
    disabled: Boolean,
  },
  computed: {
    optionWidthPct(): number {
      return 100 / this.options.length
    },
    selectedOptionIndex(): number {
      return this.options.findIndex(option => option.id === this.value)
    },
  },
})
